import componentStyles from './slider.css.lit.ts';
import { OutlineImageSlider } from '../../base/outline-image-slider/outline-image-slider.ts';
import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

export default class Slider extends OutlineImageSlider {
  static styles = [super.styles, componentStyles];

  getOptions() {
    return {
      ...super.getOptions(),
      keyboard: true,
      gap: '51px',
      perPage: 4,
      updateOnMove: true,
      breakpoints: {
        1440: {
          perPage: 3,
        },
        1024: {
          perPage: 2,
          perMove: 1,
          gap: '20px',
        },
        480: {
          perPage: 1,
        },
      },
    };
  }

  constructor() {
    super();
  }

  firstUpdated() {
    super.firstUpdated();
    this.splide.mount();
    this.splide.refresh();
  }

  ListTemplate = () => {
    let counter = 0;
    const templateArr = [];

    while (counter < this.childElementCount) {
      templateArr.push(
        html` <div
          class="splide__slide"
          role="group"
          aria-label="slide ${counter + 1} of ${this.childElementCount}"
        >
          <slot name="image-${counter + 1}"></slot>
        </div>`
      );

      counter++;
    }

    return templateArr;
  };

  render() {
    return html`
      <section
        class="${classMap({
          'splide': true,
          'splide--full': this.childElementCount > 4,
          'splide--small': this.childElementCount <= 4,
        })}"
      >
        <div class="splide__arrows">
          <button class="splide__arrow splide__arrow--prev">
            <hf-icon name="arrow-left" class="splide__arrow--icon"></hf-icon>
          </button>
          <button class="splide__arrow splide__arrow--next">
            <hf-icon name="arrow-right" class="splide__arrow--icon"></hf-icon>
          </button>
        </div>
        <div class="splide__track">
          <div class="splide__list">${this.ListTemplate()}</div>
        </div>
      </section>
    `;
  }
}

customElements.define('hf-slider', Slider);
